import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { AppRouter } from './router';
import { store } from '@store/index';
import { useDispatch } from 'react-redux';
import { initializeAuth } from '@store/authSlice';

const AppContent: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Initialize auth state from localStorage on app start
    dispatch(initializeAuth());
  }, [dispatch]);

  return <AppRouter />;
};

function App() {
  return (
    <Provider store={store}>
      <AppContent />
    </Provider>
  );
}

export default App;
